const numberWithSpaces = (amount) => amount.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

// time_str formed this way: YYYY-MM-DDTHH:MM:SS.000+01:00
export default (number) => {
  if (number === null) return;

  let numberFormatted = number.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');
  const numberCtn = numberFormatted;
  numberFormatted = numberWithSpaces(numberCtn);

  return numberFormatted;
}
